// extracted by mini-css-extract-plugin
module.exports = {"root":"_601156","item":"_346763","appContainer":"_46e732","logo":"_18974f","deleteIconButton":"_275321","appName":"_993228","emptyItem":"_80c3b2","addIcon":"_953502"};